// src/components/ChannelSummaryCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import { formatTimeRelative } from '../utils/formatters';
import './ChannelSummaryCard.css';

const ChannelSummaryCard = ({ channel, latestPost, totalCount }) => {
    const additionalCount = totalCount - 1;

    return (
        <article className="channel-summary-card">
            <Link to={`/discuss?channel=${channel.id}`} className="channel-summary-link">
                <div className="channel-summary-header">
                    <span className="channel-name">#{channel.name}</span>
                    <span className="channel-time">{formatTimeRelative(latestPost.created_at)}</span>
                </div>

                <div className="channel-latest-message">
                    <span className="latest-author">{latestPost.user?.username || 'Unknown'}:</span>
                    <span className="latest-content">{latestPost.content}</span>
                </div>

                {additionalCount > 0 && (
                    <div className="channel-more">
                        +{additionalCount} more message{additionalCount > 1 ? 's' : ''}
                    </div>
                )}
            </Link>
        </article>
    );
};

export default ChannelSummaryCard;
